export class UserModel {
    userSurrKey: number = 0;
    userName: string = "";
    userSurName: string = "";
    userEmail: string = "";
    userPhone: string = "";
    obsolete: boolean;
    userCountry: string = "";
    userLanguage: string = "";
    userAddress: string = "";
    userAmphur: string = "";
    userAvatar: string;
    comment: string;
    poCount: number;
    createdDateUser: string = "";
    createdDateEmployee: string = "";
    companySurrKey: number = 0;
    companyName: string = "";
    companyTypesName: string = "";
    companyProvince: string = "";
    roles: string = "";
    emailConfirmed: boolean;
    lockoutEnabled: boolean;
    accessFailedCount: number;
    isRegister: boolean = false;
    activateDate: string = "";
    statusEmail: string = "";
}
